const IntersectionObserverAnimations = () => {

	let observer = new IntersectionObserver((entries, observer) => {
			entries.forEach(entry => {
				if(/*entry.intersectionRatio !== 0*/entry.isIntersecting) {
					entry.target.classList.add('in-view');
					observer.unobserve(entry.target);
				}
			});
		},
{rootMargin: '0px 0px -70px 0px'});

	// The elements
	const domElToObserve = [
		'.io-animation',
	];

	// Set small timeout so the dom elements have time to get to their starting position before coming into .in-view position
	setTimeout(() => {
		document.querySelectorAll(domElToObserve.join(',')).forEach(el => { observer.observe(el) });
	}, 10);
};

export default IntersectionObserverAnimations;

